import { http } from "@common";
import endpoint from "../endpoint_cis";

export default {
    staffAcessAllPaging: (data) => {
        return http.post(endpoint.admin.Report_FindStaffAcessAllPaging, data);
    },
    staffAcessCreateRunNow: (data) => {
        return http.post(endpoint.admin.Report_StaffAcessCreateRunNow, data);
    },
    staffAcessDownload: (data) => {
        return http.download(endpoint.admin.Report_StaffAcessDownload, data);
    },
    staffAcessUpdateScheduler: (data) => {
        return http.post(endpoint.admin.Report_StaffAcessUpdateScheduler, data);
    },
    staffAcessFindSchedulerRules: (data) => {
        return http.post(endpoint.admin.Report_StaffAcessFindSchedulerRules, data);
    },
    auditLogsPaging: (data) => {
        return http.post(endpoint.admin.Report_AuditLogsPaging, data);
    },
    auditLogsDownload: (data) => {
        return http.download(endpoint.admin.Report_AuditLogsDownload, data);
    },
    testAuditLogsDownload: (data) =>{
        return http.downloadGet(endpoint.admin.Report_AuditLogsDownload, data);
    },
    singInLogsPaging: (data) => {
        return http.post(endpoint.admin.Report_SingInLogsPaging, data);
    },
    signInDownload: (data) => {
        return http.download(endpoint.admin.Report_SignInDownload, data);
    },
    testSigninDownload: (data) => {
        return http.downloadGet(endpoint.admin.Report_SignInDownload, data)  
    },
    suspiciousPaging: (data) => {
        return http.post(endpoint.admin.Report_SuspiciousPaging, data);
    },
    suspiciousDownload: (data) => {
        return http.download(endpoint.admin.Report_SuspiciousDownload, data);
    },
    applicationUsageAll: (data) => {
        return http.post(endpoint.admin.Report_ApplicationUsagePaging, data);
    },
    applicationUsageFindCisAll: (data) => {
        return http.post(endpoint.admin.Report_ApplicationUsageFindCisAll, data);
    },
    applicationUsageFindCisAllDownload: (data) => {
        return http.download(endpoint.admin.Report_ApplicationUsageFindCisAllDownload, data);
    },
    studentManagementPaging: (data) => {
        return http.post(endpoint.admin.StudentManagement_Paging, data);
    },
    studentManagementResetPassword: (data) => {
        return http.post(endpoint.admin.StudentManagement_ResetPassword.format(data));
    },
    studentManagementResetMFA: (data) => {
        return http.post(endpoint.admin.StudentManagement_ResetMFA.format(data));
    },
    emailTemplatePaging: (data) => {
        return http.post(endpoint.admin.emailTemplate_Paging, data);
    },
    emailTemplateUpdate: (data) => {
        return http.put(endpoint.admin.emailTemplateUpdate_Put, data);
    },
    studentManagementUpdate: (data) => {
        return http.put(endpoint.admin.studentManagementUpdate_Put, data);
    },
    statusReasonFilter: () => {
        return http.post(endpoint.admin.statusReasonFilter_Post);
    },
    groupManagementPaging: (data) => {
        return http.post(endpoint.admin.GroupManagement_Paging_Post, data);
    },
    groupManagementDetails: (data) => {
        return http.post(endpoint.admin.GroupManagement_details_Post, data);
    },
    ihlFilter: () => {
        return http.post(endpoint.admin.StudentManagement_ihlFilter_Post);
    },
    groupsIhlFilter: () => {
        return http.post(endpoint.admin.GroupManagement_ihlFilter_Post);
    },
    groupManagementDownload: (data) => {
        return http.download(endpoint.admin.GroupManagement_Download, data);
    },
    FindRoleType: () => {
        return http.post(endpoint.admin.GroupManagement_FindRoleType);
    },
    photoSave: (data) => {
        return http.post(endpoint.admin.Photo_save, data);
    },

};